import React, { Component } from 'react';

class Features extends Component {
    render() {
        return(
            <section id="features" className="features-section section">
                <div className="container">
                {/* <!-- SECTION 2 HEADING --> */}
                    <div className="row justify-content-center">
                        <div className="col-lg-6 text-center">
                            <h2 className="section-heading text-center">Close Up Features</h2>
                            <p>We're facilitating the creation of an experience that is made easy, friendly, and stress free,
                                allowing your experience to be memorable and fun. Our features support that mission. Take a look.</p>
                        </div>
                    </div>
                    <div className="row featuers-list-wrapper">
                        {/* <!-- FEATURES LEFT --> */}
                        <div className="col-lg-4 col-xs-12 order-lg-1">
                            <ul className="features-list features-list-left">
                                <li className="features-list-item">
                                <h3>Dining Selector</h3>
                                <p>Let us choose whats trending, chef's choice, economically friendly, new places, or add your own
                                    filters and restuarants.</p>
                                </li>
                                <li className="features-list-item">
                                <h3>User Friendly</h3>
                                <p>Our purpsoe creates a fun enjoyable experience that is enhanced by the simple, easy to use,
                                    user based interface.</p>
                                </li>
                            </ul>
                        </div>
                        {/* <!-- FEATURES RIGHT --> */}
                        <div className="col-lg-4 col-xs-12 order-lg-3">
                            <ul className="features-list features-list-right">
                                <li className="features-list-item">
                                <h3>Reviews &amp; Community</h3>
                                <p>See what top-rated critics and food enthusiasts think, or share your story with other people
                                    and rate your experience and participate in the review.</p>
                                </li>
                                <li className="features-list-item">
                                <h3>Location</h3>
                                <p>This easy to use GPS allows you to know the restuarants inside your scope of travel distance.
                                    Let us worry about how to get there.</p>
                                </li>
                            </ul>
                        </div>
                        {/* <!-- CLOSE UP PHONE IMAGE --> */}
                        <div className="col-lg-4 col-xs-12 order-lg-2 order-md-3 text-center">
                            <img src="img/iPhoneX-mock.png" className="features-image h-75" alt="test screenshot of in app use" />
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Features;